import { site, socialLinks } from "../../lib/site";

export function BlankFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="blank-footer">
      <div className="blank-footer-social">
        {socialLinks.map(({ label, href, Icon }) => (
          <a
            key={label}
            href={href}
            aria-label={label}
            target="_blank"
            rel="noreferrer noopener"
          >
            <Icon className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" />
          </a>
        ))}
      </div>

      <div className="blank-footer-mark">{site.name}</div>

      <p className="blank-footer-copy">
        © {year} {site.name}. {site.copyright}.
        <br />
        صُمّم بعناية على طراز <span dir="ltr">Blank</span>.
      </p>
    </footer>
  );
}
